import React, { useEffect, useState } from "react";
import { Button, Divider, message } from "antd";

import addCircle from "../../assets/icons/add-circle2.png";
import ModalAddCreateAudiences from "./ModalAddCreateAudiences";
import { controller } from "./controller";
import IncludedExcludedAudiences from "./automatedBoardDetails/IncludedExcludedAudiences";
import { isNotEmpty } from "../../utils";

export default function CreateBoardFormAutomatedStepTwo({ campaignId, boardId, setAutomatedStep }) {
  const [showAudienceModal, setShowAudienceModal] = useState({ type: "", show: false });
  const [loadingAudience, setLoadingAudience] = useState(false);
  const [selectedAudiences, setSelectedAudiences] = useState([]);
  const [selectedIncludeAudiences, setSelectedIncludeAudiences] = useState([]);
  const [selectedExcludeAudiences, setSelectedExcludeAudiences] = useState([]);
  const [scrollValue, setScrollValue] = useState(0); 
  const [includeCombLogic, setIncludeCombLogic] = useState("union")
  const [excludeCombLogic, setExcludeCombLogic] = useState("union")

  const fetchBoardDetails = async () => {
    try {
      const response = await controller.getBoardDetails(boardId);
      setSelectedIncludeAudiences(response.json.campaign.audience_selectors_include)
      setSelectedExcludeAudiences(response.json.campaign.audience_selectors_exclude)
      setSelectedAudiences(response.json.campaign.audience_selectors)

    } catch (err) {
      message.error("We could not fetch board details, please check your connection");
      console.error("boardDetails", err);
    } finally {
      setLoadingAudience(false);
    }
  };

  const handleIncludeExcludeClick = async (type) => {
    setShowAudienceModal({ type, show: true });
  };

  // You might want to fetch board details when the component mounts
  useEffect(() => {
    if (!boardId) return
    fetchBoardDetails();
  }, [boardId]);

  const handleDelete = async (audienceId) => {
    try {
      // setDeleting(true)
      const selectorsToSend = { campaign: { id: campaignId, audience_selectors: selectedAudiences.filter(s => s.id !== audienceId) }};
      const response = await controller.addAudiencSelectorsToBoard(boardId, selectorsToSend);      
      response.status === 204 && message.success(response.message)
      fetchBoardDetails()
    } catch (err) {
      message.error("Something went wrong while deleting the action")
      console.error("Delete action error", err)
    } finally {
      // setDeleting(false)
    }
  }

  const addCombinationLogic = async () => {
    try {
      console.log("selectedIncAudiences", selectedIncludeAudiences)
      const combinationLogic = { campaign: { id: campaignId, 
        audience_operation_for_included_audience: includeCombLogic,
        audience_operation_for_excluded_audience: excludeCombLogic,
      }};
      setLoadingAudience(true);
      const response = await controller.addAudiencSelectorsToBoard(boardId, combinationLogic);
      // getBoardDetails && getBoardDetails();

    } catch (err) {
      message.error("We could not send the combination Logic");
      console.error("", err);
    } finally {
      setLoadingAudience(false);
    }
  };

  const handleNext = async () => {
          console.log("selectedIncAudiences", selectedIncludeAudiences)
      console.log("selectedExcAudiences", selectedExcludeAudiences)

    if (selectedIncludeAudiences.length > 1 || selectedExcludeAudiences.length > 1) {
      await addCombinationLogic();
    }
    setAutomatedStep("3")
  }

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%", overflowY: "auto" }} onScroll={(e) => setScrollValue(e.target.scrollTop)}>
        <div>
          <p style={{ marginBottom: 20, fontSize: 17 }}>Audience</p>

          <div style={{ display: "flex", flexDirection: "column" }}>
            {isNotEmpty(selectedIncludeAudiences) ?       
              <IncludedExcludedAudiences audienceType="included" audiences={selectedIncludeAudiences} scrollValue={scrollValue} onAdd={handleIncludeExcludeClick} onDelete={handleDelete} 
                setCombLogic={setIncludeCombLogic} combLogic={includeCombLogic}
              />
            :
              <IncludeExcludeAudience type="include" onClick={() => handleIncludeExcludeClick("included")} />
            }
            <Divider style={{ borderColor: "#C9C1F1" }} />
            {isNotEmpty(selectedExcludeAudiences) ? 
              <IncludedExcludedAudiences audienceType="excluded" audiences={selectedExcludeAudiences} scrollValue={scrollValue} onAdd={handleIncludeExcludeClick} onDelete={handleDelete} 
                setCombLogic={setExcludeCombLogic} combLogic={excludeCombLogic}
              />
            :
              <IncludeExcludeAudience type="exclude" onClick={() => handleIncludeExcludeClick("excluded")} />            
            }
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 20 }} className="custom-scroll">
          <Button style={{ paddingInline: 40 }} onClick={() => setAutomatedStep("1")} disabled>
            Back
          </Button>

          <Button style={{ paddingInline: 40 }} type="primary" loading={loadingAudience} onClick={handleNext}>
            Next
          </Button>
        </div>
      </div>

      {/* Audience modal */}
      {showAudienceModal.show && (
        <ModalAddCreateAudiences
          showAudienceModal={showAudienceModal}
          setShowAudienceModal={setShowAudienceModal}
          boardId={boardId}
          campaignId={campaignId}
          selectedAudiences={selectedAudiences}//showAudienceModal.type === "included" ? selectedIncludeAudiences : selectedExcludeAudiences}
          setSelectedAudiences={setSelectedAudiences}//showAudienceModal.type === "included" ? setSelectedIncludeAudiences : setSelectedExcludeAudiences}
          selectedIncludeOrExudeAudiences={showAudienceModal.type === "included" ? selectedIncludeAudiences : selectedExcludeAudiences}
          setSelectedIncludeOrExcludeAudiences={showAudienceModal.type === "included" ? setSelectedIncludeAudiences : setSelectedExcludeAudiences}
          getBoardDetails={fetchBoardDetails}
        />
      )}
      
    </>
  );
}

export function IncludeExcludeAudience({ type, onClick }) {
  return (
    <div
      style={{ padding: "10px 20px", backgroundColor: "#F6F5FD", borderRadius: 10, border: "1px solid #E0DDF7", cursor: "pointer" }}
      onClick={onClick}
    >
      <p style={{ marginBottom: 10, fontSize: 14, fontWeight: 500, textTransform: "capitalize" }}>{type} Audience</p>

      <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
        <img src={addCircle} alt="plus" style={{ width: 18, height: 18 }} />
        <span style={{ fontSize: 14, color: "#6B43B5", textTransform: "capitalize" }}>Add {type} Audience</span>
      </div>
    </div>
  );
}